import { Gratuity } from "./gratuity.model";

export class Tip {
  cashTip!: boolean;
  tipPaidOut!: string;
  tipPooling!: boolean;
  autoGratuity!: boolean;
  seatMin!: number;
  gratuityPercent!: string;
  gratuity!: boolean;

  public load(data: any): this {

    Object.assign(this, data);
/*
    if (data.gratuity) {
      this.gratuity = data.gratuity;
    }
*/
    return this;
  }
}
